module.exports = __webpack_public_path__ + "img/vid_1_splash.7ae852ea.jpg";